import { render, staticRenderFns } from "./FamilyMobileConfirm.vue?vue&type=template&id=ffb0a63c&scoped=true&"
import script from "./FamilyMobileConfirm.vue?vue&type=script&lang=js&"
export * from "./FamilyMobileConfirm.vue?vue&type=script&lang=js&"
import style0 from "./FamilyMobileConfirm.vue?vue&type=style&index=0&id=ffb0a63c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffb0a63c",
  null
  
)

export default component.exports